import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { LuUsers } from "react-icons/lu";

import { Skeleton } from "@/components/ui/skeleton/skeleton";
import { getAllEmployeesQueryOptions } from "@/config/queries/query-options";
import { useMemo } from "react";

export const EmployeesCard = () => {
  const user = Cookies.get("key") as string;

  const { data, isPending } = useQuery(getAllEmployeesQueryOptions(user));

  const activeLength = useMemo(() => {
    if (isPending) {
      return 0;
    }

    if (data === undefined || data?.employees === undefined) {
      return 0;
    }

    const result = data?.employees?.filter((emp) => !emp.blocked);

    return result.length;
  }, [data, isPending]);

  return (
    <>
      {isPending ? (
        <Skeleton className="w-40 h-20"></Skeleton>
      ) : (
        <div className="w-64 h-24 rounded-md bg-card flex flex-col gap-1 shadow-sm border">
          <div className="flex flex-row items-center p-6 pb-2 justify-between">
            <h2 className="text-sm font-medium">Employees</h2>

            <LuUsers className="w-3 h-3" />
          </div>
          <div className="p-6 pt-0">
            <div className="text-2xl font-bold">{activeLength || 0}</div>
          </div>
        </div>
      )}
    </>
  );
};
